function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n            .cls-1ss-geg{fill:#fff;stroke:#1b1464;stroke-width:1.2px}.cls-2{fill:#1b1464}.cls-3{fill:#d53d53}.cls-7{fill:#31adff}.cls-8{stroke:none}.cls-9{fill:none}\r\n        "));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "eeeyu-Group_4449"
}, /*#__PURE__*/React.createElement("g", {
  id: "eeeyu-Rectangle_1990",
  className: "cls-1ss-geg"
}, /*#__PURE__*/React.createElement("rect", {
  width: 19.814,
  height: 14.631,
  className: "cls-8",
  rx: 2.5
}), /*#__PURE__*/React.createElement("rect", {
  width: 18.614,
  height: 13.431,
  x: 0.6,
  y: 0.6,
  className: "cls-9",
  rx: 1.9
})), /*#__PURE__*/React.createElement("path", {
  id: "eeeyu-Path_9052",
  d: "M0 0h19.138v2.146H0z",
  className: "cls-2",
  transform: "translate(.015 3.902)"
}), /*#__PURE__*/React.createElement("rect", {
  id: "eeeyu-Rectangle_1992",
  width: 5.944,
  height: 1.951,
  className: "cls-3",
  rx: 0.975,
  transform: "translate(2.972 8.974)"
}));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "eeeyu-Group_4450",
  transform: "translate(10.898 6.057)"
}, /*#__PURE__*/React.createElement("g", {
  id: "eeeyu-Group_4448"
}, /*#__PURE__*/React.createElement("rect", {
  id: "eeeyu-Rectangle_1990-2",
  width: 22.267,
  height: 16.582,
  fill: "#fff",
  rx: 4
})), /*#__PURE__*/React.createElement("g", {
  id: "eeeyu-Group_4446",
  transform: "translate(2.453 1.951)"
}, /*#__PURE__*/React.createElement("g", {
  id: "eeeyu-Group_4058"
}, /*#__PURE__*/React.createElement("g", {
  id: "eeeyu-Rectangle_1990-3",
  fill: "#fff",
  stroke: "#324577",
  strokeWidth: "1.2px"
}, /*#__PURE__*/React.createElement("rect", {
  width: 19.508,
  height: 14.631,
  className: "cls-8",
  rx: 3
}), /*#__PURE__*/React.createElement("rect", {
  width: 18.308,
  height: 13.431,
  x: 0.6,
  y: 0.6,
  className: "cls-9",
  rx: 2.4
})), /*#__PURE__*/React.createElement("path", {
  id: "eeeyu-Rectangle_1991",
  fill: "#324577",
  d: "M0 0H17.883V3.135H0z",
  transform: "translate(1.084 3.919)"
}), /*#__PURE__*/React.createElement("rect", {
  id: "eeeyu-Rectangle_1992-2",
  width: 3.251,
  height: 1.568,
  className: "cls-7",
  rx: 0.784,
  transform: "translate(2.655 10.071)"
}), /*#__PURE__*/React.createElement("rect", {
  id: "eeeyu-Rectangle_1993",
  width: 4.335,
  height: 1.568,
  className: "cls-7",
  rx: 0.784,
  transform: "translate(6.99 10.071)"
})), /*#__PURE__*/React.createElement("g", {
  id: "eeeyu-Group_4447"
}, /*#__PURE__*/React.createElement("g", {
  id: "eeeyu-Rectangle_1990-4",
  className: "cls-1ss-geg"
}, /*#__PURE__*/React.createElement("rect", {
  width: 19.508,
  height: 14.631,
  className: "cls-8",
  rx: 2.5
}), /*#__PURE__*/React.createElement("rect", {
  width: 18.308,
  height: 13.431,
  x: 0.6,
  y: 0.6,
  className: "cls-9",
  rx: 1.9
})), /*#__PURE__*/React.createElement("path", {
  id: "eeeyu-Rectangle_1991-2",
  d: "M0 0H18.858V2.146H0z",
  className: "cls-2",
  transform: "translate(0 3.677)"
}), /*#__PURE__*/React.createElement("rect", {
  id: "eeeyu-Rectangle_1992-3",
  width: 5.853,
  height: 1.951,
  className: "cls-3",
  rx: 0.975,
  transform: "translate(2.926 8.945)"
}))));

var SvgHMoneyTransfer = function SvgHMoneyTransfer(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "eeeyu-Group_4451",
    width: 33.164,
    height: 22.639,
    viewBox: "0 0 33.164 22.639",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHMoneyTransfer, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/h-moneyTransfer.bf91ce29.svg";
export { ForwardRef as ReactComponent };